const UNITS = ['B', 'KB', 'MB', 'GB']

export const formatFileSize = (bytes) => {
  if (!Number.isFinite(bytes) || bytes < 0) return ''

  let value = bytes
  let unitIndex = 0
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024
    unitIndex += 1
  }
  const rounded = unitIndex === 0 || value >= 10 ? Math.round(value) : Math.round(value * 10) / 10

  return `${rounded} ${UNITS[unitIndex]}`
}
